import type { AuthCodeError, AuthCodeItem } from 'AuthCode-Types';

import { fetchAuthCode, logout, refreshAuthCode } from './actions';

import { createSlice } from '@reduxjs/toolkit';

export interface AuthCodeState {
  isFetching: boolean;
  error: AuthCodeError;
  item: AuthCodeItem;
}

const initialState: AuthCodeState = {
  isFetching: false,
  error: {} as AuthCodeError,
  item: {} as AuthCodeItem,
};

const authCodeSlice = createSlice({
  name: 'authCode',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Auth Code
      .addCase(fetchAuthCode.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchAuthCode.fulfilled, (state, action) => {
        state.isFetching = false;
        state.item = action.payload;
        state.error = {} as AuthCodeError;
      })
      .addCase(fetchAuthCode.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload || ({} as AuthCodeError);
        state.item = {} as AuthCodeItem;
      })
      // Refresh Auth Code
      .addCase(refreshAuthCode.fulfilled, (state, action) => {
        state.item = action.payload;
        state.error = {} as AuthCodeError;
      })
      .addCase(refreshAuthCode.rejected, (state, action) => {
        state.error = action.payload || ({} as AuthCodeError);
      })
      // Logout
      .addCase(logout.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.isFetching = false;
        state.item = action.payload;
      })
      .addCase(logout.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload || ({} as AuthCodeError);
      });
  },
});

export const authCodeReducer = authCodeSlice.reducer;
